import { createClient } from "@supabase/supabase-js";

// Supabase configuration sourced from Vite environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log("Supabase URL:", supabaseUrl);
console.log("Supabase Key:", supabaseAnonKey ? "Set" : "Missing");

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Debug: Test if client is properly created
console.log("Supabase client created:", !!supabase);
console.log("Supabase.from method:", typeof supabase?.from);
